// extracted by mini-css-extract-plugin
export default {"content":"ProductDetails_content__Dwf4o"};